import { useCallback } from "react";
import { IOpenPanel } from "../../../../../Interfaces/IPanel";
import { PanelHeader } from "../../../../../components/Panel/PanelHeader";
import { Panel, TextField } from "@fluentui/react";
import { PanelFooter } from "../../../../../components/Panel/PanelFooter";
import { ITurnoListRequest } from "../../../../../Interfaces/auxiliar/ITurno";
import { UsePanelTurnoFiltro } from "./usePanelTurnoFiltro";
import { PanelHeaderBasic } from "../../../../../components/Panel/PanrlHeaderBasic";

export interface IPanelTurnoFiltro extends IOpenPanel {
  reload: () => void
  filtro: ITurnoListRequest
  setFiltro: React.Dispatch<React.SetStateAction<ITurnoListRequest>>
}
export const PanelTurnoFiltro = (props: IPanelTurnoFiltro) => {
  const { filtrar, cerrarPanel } = UsePanelTurnoFiltro(props)
  const onRenderHeader = useCallback(
    () => (
      <PanelHeaderBasic
        subTextHeader=""
        textHeader="Filtrar Turno"
      />
    ),
    []
  );
  const onRenderFooter = useCallback(
    () => (
      <>
        <PanelFooter
          texto="Filtrar"
          texto2={"Salir"}
          onClick={filtrar}
          disableButton={false}
          onDismiss={() => {
            cerrarPanel()
          }}
        />
      </>
    ),
    [props.filtro]
  );
  return (
    <Panel
      isOpen={props.isOpen}
      onDismiss={cerrarPanel}
      onRenderFooter={onRenderFooter}
      isFooterAtBottom
      onRenderHeader={onRenderHeader}
    >
      <TextField
        type="text"
        label="Nombre de Turno"
        placeholder="Ingrese Nombre"
        autoComplete="off"
        value={props.filtro.nombre}
        onChange={(event, newValue) => {
          if (newValue != null) {
            props.setFiltro({ ...props.filtro, nombre: newValue })
          }
        }}
      />
      <TextField
        type="text"
        label="Código de Turno"
        placeholder="Ingrese Código"
        autoComplete="off"
        value={props.filtro.codigo}
        onChange={(event, newValue) => {
          if (newValue != null) {
            props.setFiltro({ ...props.filtro, codigo: newValue })
          }
        }}
      />
      <TextField
        type="time"
        label="Hora Inicio"
        placeholder="Ingrese Hora Inicio"
        autoComplete="off"
        value={props.filtro.horaInicio}
        onChange={(event, newValue) => {
          console.log(newValue)
          if (newValue != null) {
            props.setFiltro({ ...props.filtro, horaInicio: newValue })
          }
        }}
      />
      <TextField
        type="time"
        label="Hora Fin"
        placeholder="Ingrese Hora Fin"
        autoComplete="off"
        value={props.filtro.horaFin}
        onChange={(event, newValue) => {
          if (newValue != null) {
            props.setFiltro({ ...props.filtro, horaFin: newValue })
          }
        }}
      />

    </Panel>
  )
}